// extracted by mini-css-extract-plugin
module.exports = {"ratingInfo":"RatingFooter_ratingInfo__PnHVH","ratingDate":"RatingFooter_ratingDate__TTNUg","calculationLink":"RatingFooter_calculationLink__VOfrf"};